import React from 'react'
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import {
  TwitterShareButton,
  TwitterIcon,
  FacebookShareButton,
  FacebookIcon,
  RedditShareButton,
  RedditIcon,
  LinkedinShareButton,
  LinkedinIcon
} from 'react-share'

export const ShareButtons = ({title, url, twitterHandle, tags}) => {

    return(
        <div>
      <br/>
          <p style={{textAlign: 'center'}}>
          Spread the word:
          </p>
        <div css={ShareButtonsStyles} >
          <FacebookShareButton url={url}>
                <FacebookIcon style={{fill:"none"}} size={44} />
         </FacebookShareButton>

          <TwitterShareButton url={url} title={title} via={twitterHandle} hashtags={tags}>
                <TwitterIcon  size={44} />
          </TwitterShareButton>

          <RedditShareButton url={url} title={title} >
            <RedditIcon  size={44} />
          </RedditShareButton>

          <LinkedinShareButton url={url} >
            <LinkedinIcon  size={44} />
          </LinkedinShareButton>
        </div>
        </div>
      )

}

const ShareButtonsStyles = css`
   svg {
      rect {
        fill: none;
      }
    }
    svg:hover {
      path {
        fill: #3eb0ef;
        color: #3eb0ef;
      }
    }
   text-align: center;
`
